import React from 'react';

import Article from '../../components/Article';
import MarkdownBody from '../../components/MarkdownBody';

export interface Post {
  title: string;
  subtitle: string;
  path: string;
  postedAt: Date;
  body: string;
}

export function PostComponent({ title, subtitle, path, postedAt, body }: Post) {
  return (
    <Article.T title={title} subtitle={subtitle} path={path} postedAt={postedAt}>
      <MarkdownBody>{body}</MarkdownBody>
    </Article.T>
  );
}

export function toArticle(post: Post) {
  return { ...post, Component: () => <PostComponent {...post} /> };
}
